import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../../classes/gruppe-tier';
import { GruppeTierService } from '../../gruppe-tier.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { Client } from '../../../client/classes/client';
import { Betriebskontakt } from '../../../stammdaten/betriebskontakte/betriebskontakt';

@Component({
    selector: 'lib-gruppe-tier-herkunft-bearbeiten-dialog',
    templateUrl: './gruppe-tier-herkunft-bearbeiten-dialog.component.html',
    styleUrls: ['./gruppe-tier-herkunft-bearbeiten-dialog.component.scss'],
})
export class GruppeTierHerkunftBearbeitenDialogComponent implements OnInit {
    tier: GruppeTier;
    isLoading = false;
    herkunftForm: FormGroup;
    selectedBetrieb: Betriebskontakt | null = null;

    constructor(
        public dialogRef: MatDialogRef<GruppeTierHerkunftBearbeitenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private gruppeTierService: GruppeTierService,
        private messageService: MessageService,
        private dialog: MatDialog,
    ) {
        this.tier = data.tier;
        this.initForm();
    }

    ngOnInit(): void {
        this.populateForm();
    }

    private initForm(): void {
        this.herkunftForm = new FormGroup({
            herkunft_vvvo: new FormControl({ value: '', disabled: true }),
            herkunft_betrieb: new FormControl({ value: '', disabled: true }),
            herkunft_strasse: new FormControl({ value: '', disabled: true }),
            herkunft_plz: new FormControl({ value: '', disabled: true }),
            herkunft_ort: new FormControl({ value: '', disabled: true }),
            herkunft_ortsteil: new FormControl({ value: '', disabled: true }),
        });
    }

    private populateForm(): void {
        if (this.tier) {
            this.herkunftForm.patchValue({
                herkunft_vvvo: this.tier.herkunft_vvvo || '',
                herkunft_betrieb: this.tier.herkunft_betrieb || '',
                herkunft_strasse: this.tier.herkunft_strasse || '',
                herkunft_plz: this.tier.herkunft_plz || '',
                herkunft_ort: this.tier.herkunft_ort || '',
                herkunft_ortsteil: this.tier.herkunft_ortsteil || '',
            });

            // Set selectedBetrieb only if herkunft_betrieb has actual content
            if (this.tier.herkunft_betrieb && this.tier.herkunft_betrieb.trim() !== '') {
                this.selectedBetrieb = {
                    kunde_id: 0, // Placeholder, da wir keine echte kunde_id haben
                    bezeichnung: this.tier.herkunft_betrieb,
                    bezeichnung_final: this.tier.herkunft_betrieb,
                    vvvo: this.tier.herkunft_vvvo || '',
                    strasse: this.tier.herkunft_strasse || '',
                    plz: this.tier.herkunft_plz || '',
                    ort: this.tier.herkunft_ort || '',
                    ortsteil: this.tier.herkunft_ortsteil || '',
                    zusatz: '',
                    zusatz_final: '',
                    betriebsart_bezeichnung: '',
                    kontakt_id: 0,
                    benutzer_id: 0,
                    favorit: 0,
                    ist_kunde: 0,
                    erstellt: new Date().toISOString(),
                    erstellt_von: 0,
                    editiert: new Date().toISOString(),
                    editiert_von: 0,
                } as Betriebskontakt;
            } else {
                this.selectedBetrieb = null;
            }
        }
    }

    save(): void {
        const formData = this.herkunftForm.getRawValue();

        // Allow saving even if no handler is selected (to remove handler)
        this.isLoading = true;

        // Use empty strings instead of null for better backend compatibility
        this.tier.herkunft_vvvo = formData.herkunft_vvvo || '';
        this.tier.herkunft_betrieb = formData.herkunft_betrieb || '';
        this.tier.herkunft_strasse = formData.herkunft_strasse || '';
        this.tier.herkunft_plz = formData.herkunft_plz || '';
        this.tier.herkunft_ort = formData.herkunft_ort || '';
        this.tier.herkunft_ortsteil = formData.herkunft_ortsteil || '';

        this.gruppeTierService.updateHerkunft(this.tier).subscribe({
            next: (updatedTier: GruppeTier) => {
                this.isLoading = false;
                if (formData.herkunft_betrieb) {
                    this.messageService.infoMessage('Herkunftsbetrieb erfolgreich aktualisiert.');
                } else {
                    this.messageService.infoMessage('Herkunftsbetrieb erfolgreich entfernt.');
                }
                this.dialogRef.close(updatedTier);
            },
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler beim Aktualisieren des Herkunftsbetriebs!', err);
            },
        });
    }

    removeHandler(): void {
        this.selectedBetrieb = null;
        this.herkunftForm.patchValue({
            herkunft_vvvo: '',
            herkunft_betrieb: '',
            herkunft_strasse: '',
            herkunft_plz: '',
            herkunft_ort: '',
            herkunft_ortsteil: '',
        });
    }

    cancel(): void {
        this.dialogRef.close();
    }

    onBetriebskontaktSelected(kontakt: Betriebskontakt): void {
        if (kontakt) {
            this.selectedBetrieb = kontakt;
            // Automatisch die Betriebsdaten ausfüllen
            this.herkunftForm.patchValue({
                herkunft_vvvo: kontakt.vvvo || '',
                herkunft_betrieb: kontakt.bezeichnung_final || kontakt.bezeichnung || '',
                herkunft_strasse: kontakt.strasse_final || kontakt.strasse || '',
                herkunft_plz: kontakt.plz_final || kontakt.plz || '',
                herkunft_ort: kontakt.ort_final || kontakt.ort || '',
                herkunft_ortsteil: kontakt.ortsteil || '',
            });
        }
    }

    onBetriebskontakteSelected(kontakte: Betriebskontakt[]): void {
        if (kontakte && kontakte.length > 0) {
            this.onBetriebskontaktSelected(kontakte[0]);
        }
    }
}
